import { Component, OnInit, QueryList, ViewChildren, ViewEncapsulation } from "@angular/core";
import { TableLazyLoadEvent } from "primeng/table";
import { HttpClient, HttpParams } from "@angular/common/http";
import { PAGINATION_OPTIONS } from "@app/components/supplies/supplies.component";
import { Router } from "@angular/router";
import { DataService } from "@app/services/data.service";
import { Tooltip } from "primeng/tooltip";
import { DistributionController } from "@app/ui_controllers/distributionController";
import { SubDistributionDozController } from "@app/ui_controllers/subDistributionDozController";
import { MedNotificationService } from "@mk/med-notification";
import { StatusTranslatorService } from "@app/services/status.translator.service";

@Component({
  selector: "app-distributionsDoz",
  templateUrl: "./distributions.doz.component.html",
  styleUrls: ["/distributions.doz.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class DistributionsDozComponent implements OnInit {

  constructor(private http: HttpClient,
              private router: Router,
              public dataService: DataService,
              public statusTranslatorService: StatusTranslatorService,
              private readonly distributionController: DistributionController,
              private readonly subDistributionDozController: SubDistributionDozController,
              private readonly notifications: MedNotificationService) {

  }

  @ViewChildren(Tooltip) tooltips!: QueryList <Tooltip>;

  distributions: any[] = [];
  selectedPageNumber = 1;
  pageSize = 10;
  totalRows = 0;
  tabHeaderForDOZ: {key: string; label: string;}[] = [
    { key: "id", label: "Номер розподілу" },
    { key: "orderDate", label: "Дата розподілу" },
    { key: "status", label: "Статус" },
    { key: "mnn", label: "МНН" },
    { key: "direction", label: "Напрям" },
    { key: "subDirection", label: "Піднапрям" },
    { key: "recipientBase", label: "База-отримувач" },
    { key: "distributed", label: "Розподілено" },
    { key: "action", label: "" },
  ];
  tableState: TableLazyLoadEvent = {};
  content = "";
  expandedRows: any = {};
  rowsToRemove: any = {};
  loadingCounter = 0;
  protected readonly paginationOptions = PAGINATION_OPTIONS;

  ngOnInit(): void {
    this.loadColumnOrder();
  }

  loadData($event: TableLazyLoadEvent) {
    this.tableState = $event;
    this.getDistributions(this.selectedPageNumber, $event.sortOrder === 1 ? "asc" : "desc", $event.sortField?.toString());
  }

  saveColumnOrder() {
    localStorage.setItem("distributionsDozColumnOrder", JSON.stringify(this.tabHeaderForDOZ));
  }

  loadColumnOrder() {
    const savedOrder = localStorage.getItem("distributionsDozColumnOrder");
    if (savedOrder) {
      this.tabHeaderForDOZ = JSON.parse(savedOrder);
    }
  }

  getDistributions(
    page: number | undefined,
    order = "desc",
    field = "id",
  ): void {
    let params = new HttpParams();
    this.selectedPageNumber = page ? page : 0;
    const sortFieldAndOrder = `${field},${order}`;
    params = params.append("page", this.selectedPageNumber - 1);
    params = params.append("size", this.pageSize);
    params = params.append("sort", sortFieldAndOrder);

    setTimeout(() => {
      this.loadingCounter++;
    }, 0);

    this.distributionController.getDistributionsDoz(params).subscribe(data => {
      this.distributions = data["content"];
      this.totalRows = data["totalElements"];
      setTimeout(() => {
        this.loadingCounter--;
      }, 0);
    });
  }

  pageChange(pageNumber: number) {
    this.selectedPageNumber = pageNumber;
    this.loadData(this.tableState);
  }

  pageSizeChanged(pageSize: number) {
    this.pageSize = pageSize;
    this.selectedPageNumber = 1;
    this.loadData(this.tableState);
  }

  getFirstShowedRowIndex() {
    return this.selectedPageNumber === 1 ? 0 : (this.selectedPageNumber - 1) * this.pageSize;
  }

  goToDistribution(distributionId: string, distributionType: string, parentId: string) {
    if (distributionType === "ДОЗ") {
      this.goToSubDistribution(distributionId, parentId);
    } else if (this.dataService.userRoleValue.getValue() === "DOZ") {
      // @ts-ignore
      this.router.navigate(["/distributions/doz/view/" + distributionId], { state: { breadcrumb: { alias: "Розподіл n1" } } });
    } else {
      this.router.navigate(["/distribution/view/" + distributionId]);
    }
  }

  goToSubDistribution(subDistributionId: string, parentId: string) {
    this.router.navigate(["/sub/distribution/doz/view/" + parentId + "&" + subDistributionId], { state: { breadcrumb: { alias: "Розподіл n1" } } });
  }

  getPathToStatusImg(rowElement: string): string {
    let color: string;
    switch (rowElement) {
    case "DRAFT": color = "grey"; break;
    case "PENDING_APPROVAL": color = "yellow"; break;
    case "AWAITING_DOZ_DISTRIBUTION": color = "yellow"; break;
    default: color = "green";
    }
    return `assets/icons/table/Statys_indicator_${color}.png`;
  }

  trackByIndex(index: number): number {
    return index;
  }

  expandRow(row: any, rowIndex: number): void {
    delete this.expandedRows[row];
    this.subDistributionDozController.getSubDistributions(row.id).subscribe(data => {
      if (data && data.length > 0) {
        // @ts-ignore
        data.forEach(distr => {
          distr["embedded"] = true;
          distr["direction"] = { shortName: "", name: "" };
        });

        this.distributions.splice(rowIndex + 1, 0, ...data);
        this.expandedRows[row.id] = { styleClass: "purple-10-background" };
        this.rowsToRemove[row.id] = data.length;

      } else {
        this.notifications.info("Дочірні розподіли відсутні для розподілу №" + row.id);
      }
    });
  }

  closeRow(row: any, rowIndex: number): void {
    this.distributions.splice(rowIndex + 1, this.rowsToRemove[row.id]);
    delete this.rowsToRemove[row.id];
    delete this.expandedRows[row.id];
  }

  isRowOpened(row: any): boolean {
    return !!this.expandedRows[row.id];
  }

  showTooltip(id: string, show: boolean) {

    if (!this.tooltips) {
      return;
    }

    let tooltip : Tooltip;
    this.tooltips.toArray().some(item => {
      if (item.el.nativeElement.id === id) {
        tooltip = item;
        return true;
      }
      return false;
    });
    // @ts-ignore
    if (tooltip) {
      if (show) {
        // @ts-ignore
        tooltip.activate();
      } else {
        tooltip.deactivate();
      }
    }
  }
}
